import { create } from "zustand";
import { VesselStatus } from "~/utils/constants";

type State = {
  formState: {
    open: boolean;
    shuttleId?: string;
  };
  filters: TShuttleFilters;
};

type TShuttleFilters = {
  status?: VesselStatus;
  search: string;
  page: number;
  pageSize: number;
};

type Actions = {
  setFilters: (filters: Partial<TShuttleFilters>) => void;
  resetFilters: () => void;
  openShuttleModal: (shuttleId?: string) => void;
  closeShuttleModal: () => void;
};

const initialState: TShuttleFilters = {
  search: "",
  page: 1,
  pageSize: 10,
};

export const useShuttleStore = create<State & Actions>()((set) => ({
  formState: {
    open: false,
  },
  filters: initialState,
  setFilters: (filters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  resetFilters: () => set({ filters: initialState }),
  openShuttleModal: (shuttleId) =>
    set({
      formState: {
        open: true,
        shuttleId,
      },
    }),
  closeShuttleModal: () =>
    set({ formState: { open: false, shuttleId: undefined } }),
}));
